module.exports = __webpack_public_path__ + "img/1585848989818018891.d6376135.jpg";